export const reasoningEffortStorageKey = 'chatReasoningEffort';

export const reasoningEffortValues = ['low', 'medium', 'high'] as const;

export type TChatReasoningEffort = (typeof reasoningEffortValues)[number];

export const reasoningEffortDefault = 'medium' satisfies TChatReasoningEffort;

export const reasoningEffortOptions: { value: TChatReasoningEffort; label: string }[] = [
  { value: 'medium', label: 'standard' },
  { value: 'high', label: 'deep' },
];

/** Get the reasoning effort preference. */
export function getReasoningEffort(): TChatReasoningEffort {
  const stored = localStorage.getItem(reasoningEffortStorageKey) as TChatReasoningEffort;
  if (reasoningEffortValues.includes(stored)) {
    return stored;
  }
  setReasoningEffort();
  return reasoningEffortDefault;
}

/**
 * Set the reasoning effort preference.
 *
 * @param value Omit to reset to default.
 */
export function setReasoningEffort(value: TChatReasoningEffort = reasoningEffortDefault): void {
  localStorage.setItem(reasoningEffortStorageKey, value);
}
